import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Patient } from "types/patientTypes";

export interface WorklistContext {
  accessionNumber?: string;
  studyInstanceUid?: string;
  scheduledStepId?: string;
}

export interface PatientState {
  selectedPatient: Patient | null;
  worklistContext: WorklistContext | null;
}

const initialState: PatientState = {
  selectedPatient: null,
  worklistContext: null,
};

const patientSlice = createSlice({
  name: "patient",
  initialState,
  reducers: {
    resetPaitentState() {
      return initialState;
    },
    clearPatient(state) {
      state.selectedPatient = null;
      state.worklistContext = null;
    },
    selectPatient(state, action: PayloadAction<Patient>) {
      state.selectedPatient = action.payload;
    },
    updatePatient(state, action: PayloadAction<Partial<Patient>>) {
      state.selectedPatient = {
        ...state.selectedPatient,
        ...action.payload,
      };
    },
    setWorklistContext(state, action: PayloadAction<WorklistContext | null>) {
      state.worklistContext = action.payload;
    },
  },
});

export const { resetPaitentState, clearPatient, selectPatient, updatePatient, setWorklistContext } =
  patientSlice.actions;

export default patientSlice.reducer;
